import Header from 'header'
import { About, Seo } from 'ui-components'

import { useAOS } from '~website/hooks/useAOS'

import { AppProvider } from '../AppProvider'
import { ExampleMaps } from './ExampleMaps'
import { Hero } from './Hero'

const providers = (Component) => {
  const WrappedComponent = (props) => {
    return (
      <AppProvider>
        <Seo
          title='The easiest way to make maps'
          description='Mapstack is a free-to-use online mapping tool. Use it to create interactive maps, visualisations and info graphics.'
        />
        <Component {...props} />
      </AppProvider>
    )
  }

  return WrappedComponent
}

const Landing = providers(() => {
  useAOS()

  return (
    <About
      slots={{
        Header,
        Hero,
        ExampleMaps
      }}
    />
  )
})

export { Landing }
